import { render, staticRenderFns } from "./MailtplAdd.vue?vue&type=template&id=67ca7444&"
import script from "./MailtplAdd.vue?vue&type=script&lang=js&"
export * from "./MailtplAdd.vue?vue&type=script&lang=js&"
import style0 from "./MailtplAdd.vue?vue&type=style&index=0&id=67ca7444&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports